export default __webpack_public_path__ + "static/media/T_wdt_c_cap_0.916d52eb.mp3";